import { ADMIN_USER_ID } from "@/constants/users";

export const checkIsAdmin = (userId?: string | number | null) => Number(userId) === Number(ADMIN_USER_ID);
